import * as Types from "../constants/Client";

export const resetClient = () => ({
    type: Types.RESET_CLIENT,
});

// ADD CLIENTS ACTIONS
export const addClient = (client) => ({
    type: Types.ADD_CLIENT,
    payload: client
});

export const addClientOk = () => ({
    type: Types.ADD_CLIENT_OK,
})

export const addClientFailed = (error) => ({
    type: Types.ADD_CLIENT_FAILED,
    payload: error
})

// FETCH CLIENTS ACTIONS
export const fetchClients = () => ({
    type: Types.FETCH_CLIENTS
});

export const fetchClientsOk = (clients) => ({
    type: Types.FETCH_CLIENTS_OK,
    payload: clients
})

export const fetchClientsFailed = (error) => ({
    type: Types.FETCH_CLIENTS_FAILED,
    payload: error
})

// FETCH CLIENT ID ACTIONS
export const fetchClientId = (id) => ({
    type: Types.FETCH_CLIENT_ID,
    payload: id
});

export const fetchClientIdOk = (client) => ({
    type: Types.FETCH_CLIENT_ID_OK,
    payload: client
})

export const fetchClientIdFailed = (error) => ({
    type: Types.FETCH_CLIENT_ID_FAILED,
    payload: error
})

// PATCH CLIENT ACTIONS
export const patchClient = ({ client, id }) => ({
    type: Types.PATCH_CLIENT,
    payload: { client, id }
});

export const patchClientOk = () => ({
    type: Types.PATCH_CLIENT_OK,
})

export const patchClientFailed = (error) => ({
    type: Types.PATCH_CLIENT_FAILED,
    payload: error
})